module.exports = __webpack_public_path__ + "static/img/share-download.b5c3c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/share-download.png
// module id = 72
// module chunks = 1